import React from 'react'
import {Box, Flex, Text, Link} from '@primer/components'
import InterHeading from './InterHeading.js'

const FaqItem = ({
    title,
    desc,
    href,
    link
  }) => (
      <Flex.Item as={Box} width={[1, 1, 1, 1/2]} px={[2, 6, 6, 6]} mb={6}>
        <InterHeading fontSize={3} mb={3}>{title}</InterHeading>
        <Text fontSize={2} as="p" mb={2} color="gray.6">{desc}</Text>
        <Link fontSize={2} href={href}>{link}</Link> 
      </Flex.Item> 
  )

export default FaqItem